import React from 'react'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { DownloadPdfDoctorLink } from '../pdf/doctor-template'
import { DownloadPdfNurseLink } from '../pdf/nurse-template'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'

const useStyles = makeStyles({
  bottomBar: {
    top: 'auto',
    bottom: 5,
    position: 'fixed',
    width: '70vw',
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-end'
  },
  row: {
    display: 'flex',
    alignContent: 'center',
  },
  returnUrl: {
    alignSelf: 'end',
    float: 'left'
  },
  grow: {
    flex: 1
  },
  noLink: {
    textDecoration: 'none',
    color: 'white'
  },
  active: {
    marginRight: '5px',
    background: '#548235',
    color: 'white',
    '&:hover': {
      background: '#548235',
      color: 'white',  
    }
  },
  notActive: {
    marginRight: '5px',
    background: '#bfbfbf',
    color: 'white',
    '&:hover': {
      background: '#bfbfbf',
      color: 'white',
    }
  },
  alert: {
    marginBottom: '15px'
  }
})

export interface ButtonBarProps {
  onGenerate: () => void;
  generateObject: any;
  onDownload: () => void;
  downloadDisabled: boolean;
  signDisabled: boolean;
  isDoctor: boolean;
  edit: boolean;
  isValid: boolean;
}

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const ButtonBar: React.FC<ButtonBarProps> = function (props) {
  const styles = useStyles()
  const {
    onGenerate,
    isDoctor,
    onDownload,
    downloadDisabled,
    edit,
    signDisabled,
    generateObject,
    isValid
  } = props

  return (
    <Paper className={styles.bottomBar} variant="elevation">
      { isValid && <Alert severity="error" className={styles.alert}>Proszę uzupełnić wszystkie wymagane pola.</Alert> }
      <div className={styles.row}>
        <Button className={isValid ? styles.notActive : styles.active} variant="contained" onClick={onGenerate} disabled={isValid}>{edit ? 'EDYTUJ' : 'GENERUJ DEKLARACJĘ'}</Button>
        <Button className={!edit ? styles.notActive : styles.active} variant="contained" onClick={onDownload} disabled={!edit}>
          {
            generateObject ?
            (isDoctor ? <DownloadPdfDoctorLink doctor={generateObject} /> : <DownloadPdfNurseLink nurse={generateObject} />)
            : 'POBIERZ DEKLARACJĘ'
          }
        </Button>
        <Button className={styles.active} variant="contained" disabled={signDisabled} href="https://moj.gov.pl/uslugi/signer/upload?xFormsAppName=SIGNER" target="_blank">PODPISZ</Button>
        <div style={{ flex: 1 }}></div>
        <Button color="primary" href="https://euromedis.pl/jak-zlozyc-e-deklaracje-do-poz/" variant="contained">WRÓĆ</Button>
      </div>
    </Paper>
  )
}
